/**
 * Created by wuyanbin on 2019/5/15.
 */
import * as auction from './Auction';
import * as base from './Base';
import * as finance from './Finance';
import * as goods from './Goods';
import * as order from './Order';
import * as system from './System';
import * as user from './User';
import * as longLink from './LongLink';
import * as uniApi from './UniApi';
import * as report from './Report';
import * as suixinhuan from './SuixinHuan';
export default {
    auction,
    base,
    finance,
    goods,
    order,
    system,
    user,
    longLink,
    uniApi,
    report,
    suixinhuan,
};
